import { normPhoneDigits } from './phoneCountryCodes';

const clean = (v) => String(v || '').trim();
const normEmail = (v) => clean(v).toLowerCase();

/** Clave estable del visitante del catálogo (misma lógica que retailPosEngine). */
export const catalogVisitorKey = (interes) => {
  const uid = clean(interes?.shopperUserId || interes?.shopper_user_id);
  if (uid) return `uid:${uid}`;
  const email = normEmail(interes?.shopperEmail);
  const wa = normPhoneDigits(interes?.shopperWhatsapp);
  return `contact:${email}|${wa}`;
};

export const isSameCatalogVisitor = (a, b) =>
  catalogVisitorKey(a) === catalogVisitorKey(b);
